import { createContext, useContext, useEffect, useState } from 'react';

const APIContext = createContext();

function APIContextProvider({ children }) {
    // Data
    const [apiData, setApiData] = useState([]);
    const [followersData, setFollowersData] = useState([]);
    const [followingData, setFollowingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    // Sorting
    const [sortData, setSortData] = useState([]);
    const [sortType, setSortType] = useState('default');

    // Fetch data
    const dashBaseURL = 'https://public.tableau.com/views';
    const thumbBaseURL = 'https://public.tableau.com/thumb/views';

    useEffect(() => {
        Promise.all([
            fetch('staticData/userApi.json'),
            fetch('staticData/followers.json'),
            fetch('staticData/following.json'),
        ])
            .then((response) => Promise.all(response.map((res) => res.json())))
            .then((data) => {
                setApiData(data[0]);
                setFollowersData(data[1].authorFeedInfos);
                setFollowingData(data[2].authorFeedInfos);
                setIsLoading(false);
            })
            .catch((err) => console.log(err));
    }, []);

    const visibleVizzes = apiData.filter((viz) => viz.showInProfile === true);

    // Featured Vizzes
    const visibleVizzesWithFeatured = visibleVizzes.map((viz) => {
        const data = { ...viz, isFeatured: false };

        const featuredViz =
            viz.workbookRepoUrl === 'ModernDashboard_15889039391990' ||
            viz.workbookRepoUrl === 'RegionalSalesDashboard_15887978842090' ||
            viz.workbookRepoUrl === 'RegionalSalesOverview_15887797327420' ||
            viz.workbookRepoUrl === 'WORKOUTWEDNESDAY2019WEEK41-WhichCustomersarecostingus';

        return featuredViz ? { ...data, isFeatured: true } : data;
    });

    // Sorting by
    useEffect(() => {
        const sortArray = (type) => {
            const types = {
                firstPublishDate: 'firstPublishDate',
                default: 'default',
                lastPublishDate: 'lastPublishDate',
                viewCount: 'viewCount',
            };
            const sortProperty = types[type];
            if (sortProperty === 'default') {
                const sorted = [...visibleVizzesWithFeatured]
                    .sort(
                        (a, b) =>
                            a.isFeatured - b.isFeatured ||
                            new Date(a.firstPublishDate).getTime() -
                                new Date(b.firstPublishDate).getTime()
                    )
                    .reverse();
                setSortData(sorted);
            } else if (sortProperty === 'firstPublishDate' || sortProperty === 'lastPublishDate') {
                const sorted = [...visibleVizzesWithFeatured]
                    .sort(
                        (a, b) =>
                            new Date(a[sortProperty]).getTime() -
                            new Date(b[sortProperty]).getTime()
                    )
                    .reverse();
                setSortData(sorted);
            } else if (sortProperty === 'viewCount') {
                const sorted = [...visibleVizzesWithFeatured].sort(
                    (a, b) => b[sortProperty] - a[sortProperty]
                );
                setSortData(sorted);
            }
        };

        sortArray(sortType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiData, sortType]);

    // Stats:
    const totalViews = visibleVizzes.reduce((total, acc) => total + acc.viewCount, 0);
    const numberFavorites = visibleVizzes.reduce((total, acc) => total + acc.numberOfFavorites, 0);

    return (
        <APIContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                isLoading,
                dashBaseURL,
                thumbBaseURL,
                visibleVizzes,
                followersData,
                followingData,
                sortData,
                setSortType,
                totalViews,
                numberFavorites,
            }}
        >
            {children}
        </APIContext.Provider>
    );
}

export default APIContextProvider;

// Create a hook to use the APIContext, this is a Kent C. Dodds pattern
export function useAPI() {
    const context = useContext(APIContext);
    if (context === undefined) {
        throw new Error('Context must be used within a Provider');
    }
    return context;
}
